<template>
    <div class="d-flex align-center mb-1">
        <v-row no-gutters>
            <v-col>
                <v-autocomplete
                    :label="$t('item')" 
                    v-model="line.item_id"
                    :rules="[isRequired]"
                    :readonly="!mode.edit"
                    class="me-1"
                    background-color="white" 
                    outlined 
                    :items="items"
                    item-value="id"
                    item-text="display_name"
                    dense 
                    hide-details="auto"
                    />
            </v-col>
            <!-- <v-col v-if="multiWarehouse">
                <v-autocomplete
                    label="Warehouse" 
                    v-model="line.warehouse_id"
                    :rules="[isRequired]"
                    :readonly="!mode.edit"
                    class="me-1"
                    background-color="white" 
                    outlined 
                    :items="warehouses"
                    item-text="display_name"
                    item-value="id"
                    dense 
                    hide-details="auto"
                    />
            </v-col> -->
            <v-col cols="1">
                <v-text-field
                    :label="$t('quantity')" 
                    v-model="line.quantity"
                    :readonly="!mode.edit"
                    :rules="[isRequired, isNumeric]"
                    class="me-1" 
                    background-color="white" 
                    outlined 
                    dense 
                    hide-details="auto"
                    >
                </v-text-field>
            </v-col>
            <v-col cols="1">
                <PItemMeasureUnitsSearch
                    :label="$t('measure_unit')" 
                    v-model="line.measure_unit_id" 
                    :rules="[isRequired]"
                    :readonly="!mode.edit"
                    class="me-1"
                    background-color="white" 
                    outlined 
                    item-text="name"
                    item-value="id"
                    dense 
                    hide-details="auto"
                    :item-id="line.item_id"
                    />

            </v-col>
            <!-- <v-col cols="1" v-if="!!line.avg_unit_value">
                <v-text-field 
                    label="Avg Unit Value" 
                    :value="line.avg_unit_value"
                    disabled
                    class="me-1"
                    background-color="white" 
                    outlined
                    dense 
                    hide-details="auto">
                </v-text-field>
            </v-col> -->
            <v-col cols="1" >
                <v-text-field 
                    :label="$t('unit_value')" 
                    v-model="line.unit_value"
                    :readonly="!mode.edit || !unitValueEditable"
                    :rules="[isRequired, isNumeric]"
                    :disabled="!unitValueEnabled"
                    class="me-1"
                    background-color="white" 
                    outlined
                    dense 
                    hide-details="auto"
                    @change="handleUnitValueChange">
                </v-text-field>
            </v-col>
            <v-col cols="2">
                <v-text-field
                    :label="$t('total_value')" 
                    v-model="line.value"
                    :rules="[isRequired, isNumeric]"
                    readonly
                    class="me-1" 
                    outlined 
                    dense 
                    background-color="white"
                    :suffix="baseCurrency.abbreviation"
                    hide-details="auto">
                </v-text-field>
            </v-col>
            <v-col v-if="multiAccount">
                <v-autocomplete
                    :label="$t('account')" 
                    v-model="line.account_id"
                    :rules="[isRequired]"
                    :readonly="!mode.edit"
                    class="me-1" 
                    background-color="white"
                    outlined
                    :items="userAccounts"
                    item-text="display_name"
                    item-value="id" 
                    dense 
                    hide-details="auto"
                    />
            </v-col>
            <v-col cols="2" v-if="multiDimension">
                <v-autocomplete
                    :label="$t('dimension')" 
                    v-model="line.dimension_id"
                    :readonly="!mode.edit"
                    :clearable="mode.edit"
                    background-color="white" 
                    outlined 
                    dense
                    :items="dimensions"
                    item-text="name"
                    item-value="id" 
                    hide-details="auto" 
                    ></v-autocomplete>
                    
            </v-col>
        </v-row>
        <v-btn
            icon
            :disabled="!mode.edit">
            <v-icon @click="deleteRow">mdi-close</v-icon>
        </v-btn>
    </div>
</template>

<script>
import { round } from 'lodash';
import { mapState, mapGetters } from 'vuex';

import { isRequired, isNumeric } from './../../utils/validations';
import PItemMeasureUnitsSearch from './PItemMeasureUnitsSearch';
import { getItemUnitValue } from '../../services/stock/item';

export default {
    name:'StockJournalLines',
    components: { 
        PItemMeasureUnitsSearch
    },
    props: {
        value: Object,
        multiAccount: Boolean,
        multiWarehouse: Boolean,
        multiDimension: Boolean,
        unitValueEditable: Boolean,
        mode: Object,
        documentDate: String
    },
    data() {
        return {
            isRequired,
            isNumeric,
            line: {...this.value}
        }
    },
    computed: {
        ...mapState("accounting", ["baseCurrency"]),
        unitValueEnabled() {
            return this.line.item_id && this.line.warehouse_id && this.line.measure_unit_id;
        },
        ...mapGetters({
            items: "stockJournal/item/items",
            userItems: "stockJournal/item/userItems",
            warehouses: "stockJournal/warehouse/warehouses",
            userWarehouses: "stockJournal/warehouse/userWarehouses",
            accounts: "stockJournal/account/accounts",
            userAccounts: "stockJournal/account/userAccounts",
            dimensions: "stockJournal/dimension/dimensions"
        }),
        ...mapState({
            userAccountsIDs: "stockJournal/userAccountsIDs"
        })
    },
    watch:{
        line: {
            handler(line){
                this.$emit('input',line);
            },
            deep: true
        },
        "line.quantity": {
            handler() {
                if(this.line.unit_value) {
                    this.calculateValue();
                }
            },
            deep: true
        },
        "line.item_id": {
            handler() {
                // this.fetchItemMeasureUnits();
                this.fetchItemUnitValue();
            }
        },
        "line.warehouse_id": {
            handler() {
                this.fetchItemUnitValue();
            }
        },
        "line.measure_unit_id": {
            handler() {
                this.fetchItemUnitValue();
            }
        },
        "documentDate": {
            handler() {
                this.fetchItemUnitValue();
            }
        }

    },
    methods:{
        deleteRow(){
            this.$emit('delete-row',this.line.key)
        },
        // handleValueChange() {
        //     this.calculateUnitValue();
        // },
        handleUnitValueChange() {
            this.calculateValue();
        },
        calculateValue() {
            if(isNaN(this.line.unit_value)) {
                this.line.value = null;
                return;
            }
            this.line.value = round(this.line.unit_value * this.line.quantity, 2);
        },
        // calculateUnitValue() {
        //     if(isNaN(this.line.value)) {
        //         this.line.unit_value = null;
        //         return;
        //     }
        //     if(Number(this.line.quantity) === 0) return;
        //     this.line.unit_value = round(this.line.value / this.line.quantity, 2);
        // },
        async fetchItemUnitValue() {
            if(this.unitValueEnabled) {
                let resp = await getItemUnitValue(this.line.item_id, this.line.warehouse_id, this.line.measure_unit_id, this.documentDate);
                if (!this.line.unit_value) this.line.unit_value = resp.data.value;
                this.line.unit_value = resp.data.value;
                this.line.avg_unit_value = resp.data.value;
                this.calculateValue();
            }
        }
    }
}
</script>